export class BoardApprovalProcessConstants {
    static readonly ACC = 'ACC';
    static readonly WF = 'WF';
    static readonly COLLECTIONS = 'COLLECTIONS';
}
